import { css } from "lit";

export const errorPageStyles = css`
  :host {
    display: block;
    min-height: 100vh;
    position: relative;
    overflow: hidden;
  }

  .error-page {
    position: relative;
    min-height: 100vh;
    background-color: var(--sds-color-background-default-default);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-title);
  }

  /* Main Content */
  .content {
    position: relative;
    z-index: 4;
    text-align: center;
    padding: var(--sds-size-space-800);
    max-width: 393px;
    width: 100%;
    font-family: var(--sds-typography-family-title);
    font-weight: var(--sds-typography-weight-semibold);
  }

  .error-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--sds-size-space-800);
  }

  .error-content svg {
    fill: currentColor;
  }

  .error-content svg path {
    fill: inherit;
  }

  .error-code {
    font-size: 120px;
    font-weight: var(--sds-typography-weight-semibold);
    line-height: 1;
    margin: 0;
    color: var(--sds-color-text-default-default);
    text-shadow: 0 0 40px var(--sds-color-white-100);
  }

  .error-title {
    font-size: var(--sds-typography-scale-06);
    font-weight: var(--sds-typography-weight-semibold);
    line-height: 1.2;
    margin: 0;
    color: var(--sds-color-text-default-default);
  }

  .error-message {
    font-size: var(--sds-typography-scale-03);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1.5;
    margin: 0;
    color: var(--sds-color-text-default-secondary);
    max-width: 300px;
  }

  .home-button {
    padding: var(--sds-size-space-600) var(--sds-size-space-1200);
    background: var(--sds-color-background-default-secondary);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-secondary);
    border-radius: var(--sds-size-radius-600);
    color: var(--sds-color-text-default-default);
    text-decoration: none;
    font-family: var(--sds-typography-family-title);
    font-weight: var(--sds-typography-weight-semibold);
    font-size: var(--sds-typography-scale-03);
    transition: all 0.2s ease;
    backdrop-filter: blur(10px);
  }

  .home-button:hover {
    background: var(--sds-color-background-default-secondary-hover);
    border-color: var(--sds-color-border-default-tertiary);
    transform: translateY(-2px);
  }

  .devider {
    display: flex;
    place-content: center center;
    width: 100%;
    max-width: 345px;
    background: linear-gradient(
      180deg,
      transparent calc(50% - 0.5px),
      var(--sds-color-border-default-default) calc(50% - 0.5px),
      var(--sds-color-border-default-default) calc(50% + 0.5px),
      transparent calc(50% + 0.5px)
    );
    color: var(--sds-color-text-default-secondary);

    & span {
      font-family: var(--sds-typography-family-title);
      font-weight: var(--sds-typography-weight-semibold);
      background-color: var(--sds-color-background-default-default);
      padding: 0 10px;
    }
  }

  /* Background Cards */
  .background-cards {
    --local-visible-width: calc(270px * 0.5);
    --local-shade-width: calc(95px + var(--local-visible-width));

    position: relative;
    display: flex;
    gap: var(--sds-size-space-300);
    flex-direction: column;
    transform: rotate(10deg);

    &::after {
      content: "";
      background: linear-gradient(
        90deg,
        var(--sds-color-background-default-default) calc(50% - var(--local-shade-width)),
        transparent calc(50% - var(--local-visible-width)),
        transparent calc(50% + var(--local-visible-width)),
        var(--sds-color-background-default-default) calc(50% + var(--local-shade-width))
      );
      pointer-events: none;
      position: absolute;
      z-index: 1;
      display: block;
      width: 300%;
      height: 100%;
      top: 0;
      left: -100%;
    }
  }

  .card-group {
    display: flex;
    gap: var(--sds-size-space-300);
    align-items: center;
  }

  .card-group-1 {
    animation: tiles-right 30s linear infinite;
  }

  .card-group-2 {
    animation: tiles-left 30s linear infinite;
  }

  @keyframes tiles-left {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-881.33px);
    }
  }

  @keyframes tiles-right {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(881.33px);
    }
  }
`;
